import { Dialog } from '@phi/components';
import { PropType, defineComponent, h } from 'vue';
import { ISubscriptions } from '..';
import { set } from '@phi/util/vuetils';

export const ProFeatureModal = defineComponent({
    props: {
        subscriptions: {
            required: true,
            type: Object as PropType<ISubscriptions>,
        },
    },

    setup(props) {
        const {
            subscriptions: {
                state: { showing_pro_feature_modal },
                stripe: { open_store },
            }
        } = props;

        return () => h(Dialog, {
            show: showing_pro_feature_modal.value,
            'onUpdate:show': set(showing_pro_feature_modal),
            width: 'narrower',
            title: 'Phi Professional Feature',
            confirm_label: 'Go to your account',
            onConfirm: () => {
                showing_pro_feature_modal.value = false;
                open_store();
            },
            onClose: () => showing_pro_feature_modal.value = false,
        }, () => [
            h('p', 'This feature is only available with a Professional subscription.'),
            h('p', [
                'To update your subscription plan, ',
                h('a', { href: '#', onClick: open_store }, ' go to your account'),
                '.'
            ]),
        ]);
    }
});
